import styled from 'styled-components'
import { Button } from '@/components'

const Wrapper = styled.div<{ border?: boolean }>`
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border-radius: ${props => props.theme.standardBorderRadius};
  border: ${props =>
    props.border ? `1px solid ${props.theme.colors.gray9}` : 'none'};
  background-color: ${props => props.theme.colors.white};

  & > *:first-child {
    border-right: 1px solid ${props => props.theme.colors.gray9};
    margin-right: 1rem;
    padding-right: 1rem;
  }
  & > *:last-child {
    cursor: pointer;
  }
  ${props => props.theme.media.mobile} {
    width: 100%;
  }
`

export const TextAndAction: React.FC<{
  text: string
  actionText?: string
  border?: boolean
  restrictWidth?: boolean
  onClick?: () => void
}> = ({ text, actionText, border, onClick }) => {
  return (
    <Wrapper border={border} onClick={onClick}>
      <div>{text}</div>
      <Button size="sm" onClick={onClick}>
        {actionText ? actionText : '+'}
      </Button>
    </Wrapper>
  )
}
